import { createVNode as o, mergeProps as e } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DictionaryFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (t, a) => {
  const i = {
    ...t,
    ...a.attrs
  };
  return o(d, e(i, {
    icon: n
  }), null);
};
r.displayName = "DictionaryFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
